import { render, staticRenderFns } from "./WhatsappTemplateForm.vue?vue&type=template&id=3c2fb06e&scoped=true"
import script from "./WhatsappTemplateForm.vue?vue&type=script&lang=js"
export * from "./WhatsappTemplateForm.vue?vue&type=script&lang=js"
import style0 from "./WhatsappTemplateForm.vue?vue&type=style&index=0&id=3c2fb06e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2fb06e",
  null
  
)

export default component.exports